/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsHoopCategory,
    ControlcenterMelcoModelsHoopCategoryFromJSON,
    ControlcenterMelcoModelsHoopCategoryFromJSONTyped,
    ControlcenterMelcoModelsHoopCategoryToJSON,
    ControlcenterMelcoModelsHoopMachine,
    ControlcenterMelcoModelsHoopMachineFromJSON,
    ControlcenterMelcoModelsHoopMachineFromJSONTyped,
    ControlcenterMelcoModelsHoopMachineToJSON,
    ControlcenterMelcoModelsHoopProduct,
    ControlcenterMelcoModelsHoopProductFromJSON,
    ControlcenterMelcoModelsHoopProductFromJSONTyped,
    ControlcenterMelcoModelsHoopProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsHoop
 */
export interface ControlcenterMelcoModelsHoop {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    english_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    metric_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoop
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoop
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoop
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsHoop
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    supplier_product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    asset_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsHoop
     */
    discontinued?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoop
     */
    publish_state?: number;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsHoopCategory>}
     * @memberof ControlcenterMelcoModelsHoop
     */
    category_list?: Array<ControlcenterMelcoModelsHoopCategory> | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsHoopProduct>}
     * @memberof ControlcenterMelcoModelsHoop
     */
    product_list?: Array<ControlcenterMelcoModelsHoopProduct> | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsHoopMachine>}
     * @memberof ControlcenterMelcoModelsHoop
     */
    machine_list?: Array<ControlcenterMelcoModelsHoopMachine> | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsHoop
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsHoop
     */
    published_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsHoop
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    asset?: string | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsHoop
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoop
     */
    signature?: string | null;
}

export function ControlcenterMelcoModelsHoopFromJSON(json: any): ControlcenterMelcoModelsHoop {
    return ControlcenterMelcoModelsHoopFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'english_name': !exists(json, 'english_name') ? undefined : json['english_name'],
        'metric_name': !exists(json, 'metric_name') ? undefined : json['metric_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'supplier_product_name': !exists(json, 'supplier_product_name') ? undefined : json['supplier_product_name'],
        'asset_type': !exists(json, 'asset_type') ? undefined : json['asset_type'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'category_list': !exists(json, 'category_list') ? undefined : (json['category_list'] === null ? null : (json['category_list'] as Array<any>).map(ControlcenterMelcoModelsHoopCategoryFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(ControlcenterMelcoModelsHoopProductFromJSON)),
        'machine_list': !exists(json, 'machine_list') ? undefined : (json['machine_list'] === null ? null : (json['machine_list'] as Array<any>).map(ControlcenterMelcoModelsHoopMachineFromJSON)),
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'published_date': !exists(json, 'published_date') ? undefined : (json['published_date'] === null ? null : new Date(json['published_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function ControlcenterMelcoModelsHoopToJSON(value?: ControlcenterMelcoModelsHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'english_name': value.english_name,
        'metric_name': value.metric_name,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_product_id': value.supplier_product_id,
        'supplier_product_name': value.supplier_product_name,
        'asset_type': value.asset_type,
        'type': value.type,
        'discontinued': value.discontinued,
        'publish_state': value.publish_state,
        'category_list': value.category_list === undefined ? undefined : (value.category_list === null ? null : (value.category_list as Array<any>).map(ControlcenterMelcoModelsHoopCategoryToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(ControlcenterMelcoModelsHoopProductToJSON)),
        'machine_list': value.machine_list === undefined ? undefined : (value.machine_list === null ? null : (value.machine_list as Array<any>).map(ControlcenterMelcoModelsHoopMachineToJSON)),
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'published_date': value.published_date === undefined ? undefined : (value.published_date === null ? null : value.published_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'asset': value.asset,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'signature': value.signature,
    };
}


